export const ESTADOS_ARCA = {
  PENDIENTE: "PendienteARCA",
  ENVIANDO: "EnviandoARCA",
  AUTORIZADA: "Autorizada",
  ERROR: "ErrorARCA",
  ERROR_LOCAL: "ErrorFacturaLocal",
};

export const ESTADOS_VENTA = {
  PENDIENTE_IVA: "PendienteConfiguracionIVA",
  PENDIENTE_FACTURACION: "PendienteFacturacion",
  FACTURADA: "Facturada",
  ERROR_FACTURA_LOCAL: "ErrorFacturaLocal",
};

export const POLITICAS_FACTURACION = {
  INMEDIATA: "Inmediata",
};

export const ETIQUETAS_ESTADO_FISCAL = {
  PendienteARCA: "Pendiente de autorizacion",
  EnviandoARCA: "Autorizando en ARCA...",
  Autorizada: "Factura autorizada",
  ErrorARCA: "No se pudo autorizar",
  ErrorFacturaLocal: "Venta realizada, factura pendiente",
  PendienteConfiguracionIVA: "IVA pendiente de configuración",
};

const tomar = (objeto, ...claves) => {
  for (const clave of claves) {
    if (objeto?.[clave] !== undefined && objeto?.[clave] !== null) return objeto[clave];
  }
  return undefined;
};

const normalizarDetalleStock = (respuesta = {}) => {
  const detalle = tomar(respuesta, "detalleStock", "DetalleStock");
  if (!Array.isArray(detalle)) return [];

  return detalle.map((item) => ({
    detalleId: Number(tomar(item, "detalleId", "DetalleId")) || 0,
    linea: Number(tomar(item, "linea", "Linea")) || 0,
    mercaderiaId: Number(tomar(item, "mercaderiaId", "MercaderiaId")) || 0,
    estadoStock: String(tomar(item, "estadoStock", "EstadoStock") || "NoAplica"),
    cantidadVendida: Number(tomar(item, "cantidadVendida", "CantidadVendida")) || 0,
    cantidadStockConsumida: Number(tomar(item, "cantidadStockConsumida", "CantidadStockConsumida")) || 0,
    cantidadSinStock: Number(tomar(item, "cantidadSinStock", "CantidadSinStock")) || 0,
  }));
};

export const generarUuid = () => {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (caracter) => {
    const aleatorio = Math.floor(Math.random() * 16);
    const valor = caracter === "x" ? aleatorio : (aleatorio & 0x3) | 0x8;
    return valor.toString(16);
  });
};

export const normalizarResultadoVenta = (respuesta = {}) => ({
  ventaId: Number(tomar(respuesta, "ventaId", "VentaId", "IdentificadorId")) || 0,
  identificadorId: Number(tomar(respuesta, "IdentificadorId", "identificadorId", "ventaId", "VentaId")) || 0,
  despachoId: Number(tomar(respuesta, "despachoId", "DespachoId")) || 0,
  remitoId: Number(tomar(respuesta, "remitoId", "RemitoId")) || 0,
  facturaId: Number(tomar(respuesta, "facturaId", "FacturaId")) || 0,
  remitoNumero: String(tomar(respuesta, "remitoNumero", "RemitoNumero") || ""),
  facturaNumero: String(tomar(respuesta, "facturaNumero", "FacturaNumero") || ""),
  usuarioId: Number(tomar(respuesta, "usuarioId", "UsuarioId")) || 0,
  estadoVenta: String(tomar(respuesta, "estadoVenta", "EstadoVenta") || ""),
  estadoFactura: String(tomar(respuesta, "estadoFactura", "EstadoFactura") || ""),
  emitirElectronica: Boolean(tomar(respuesta, "emitirElectronica", "EmitirElectronica")),
  ivaPendiente: Boolean(tomar(respuesta, "ivaPendiente", "IvaPendiente")),
  facturacionPendienteIva: Boolean(tomar(respuesta, "facturacionPendienteIva", "FacturacionPendienteIva")),
  error: String(tomar(respuesta, "error", "Error") || ""),
  ultimoError: String(tomar(respuesta, "ultimoError", "UltimoError") || ""),
  detalleIds: tomar(respuesta, "detalleIds", "DetalleIds") || [],
  detalleStock: normalizarDetalleStock(respuesta),
  codbar: tomar(respuesta, "codbar", "Codbar") || "",
  etiquetaCaja: tomar(respuesta, "etiquetaCaja", "EtiquetaCaja") || "",
  etiquetaCargada: tomar(respuesta, "etiquetaCargada", "EtiquetaCargada") || "",
});

export const normalizarDocumentoVenta = (respuesta = {}) => ({
  error: String(tomar(respuesta, "error", "Error") || ""),
  ventaId: Number(tomar(respuesta, "ventaId", "VentaId")) || 0,
  despachoId: Number(tomar(respuesta, "despachoId", "DespachoId")) || 0,
  remitoId: Number(tomar(respuesta, "remitoId", "RemitoId")) || 0,
  facturaId: Number(tomar(respuesta, "facturaId", "FacturaId")) || 0,
  usuarioId: Number(tomar(respuesta, "usuarioId", "UsuarioId")) || 0,
  remitoNumero: String(tomar(respuesta, "remitoNumero", "RemitoNumero") || ""),
  estadoVenta: String(tomar(respuesta, "estadoVenta", "EstadoVenta") || ""),
  estadoFiscal: String(tomar(respuesta, "estadoFiscal", "EstadoFiscal") || ""),
  motivoBloqueoFiscal: String(tomar(respuesta, "motivoBloqueoFiscal", "MotivoBloqueoFiscal") || ""),
  ultimoError: String(tomar(respuesta, "ultimoError", "UltimoError") || ""),
  fecha: String(tomar(respuesta, "fecha", "Fecha") || ""),
});

export const normalizarEstadoFiscal = (respuesta = {}, estadoAlternativo = "") => ({
  estado: String(tomar(respuesta, "estado", "Estado", "estadoFactura", "EstadoFactura") || estadoAlternativo),
  error: String(tomar(respuesta, "error", "Error") || ""),
  mensaje: String(tomar(respuesta, "mensajeFacturaElectronica", "MensajeFacturaElectronica", "mensaje", "Mensaje") || ""),
  usuarioId: Number(tomar(respuesta, "usuarioId", "UsuarioId")) || 0,
});

export const esEstadoEmitible = (estado) =>
  estado === ESTADOS_ARCA.PENDIENTE || estado === ESTADOS_ARCA.ERROR;

export const etiquetaEstadoFiscal = (estado) =>
  ETIQUETAS_ESTADO_FISCAL[estado] || estado || "Sin factura electronica";

export const mensajeSeguro = (mensaje, alternativo = "No se pudo completar la operacion.") => {
  const texto = String(mensaje || "").trim();
  if (!texto) return alternativo;
  if (/\b(stack|trace|select |insert |update |delete |soap|exception|sql|at \w+[.(])/i.test(texto)) return alternativo;
  return texto.length > 260 ? `${texto.slice(0, 257)}...` : texto;
};

export const crearRequestEmision = ({ EmpresaId, facturaId, operadorId, pcId }) => ({
  EmpresaId,
  facturaId: Number(facturaId) || 0,
  operadorId: Number(operadorId) || 0,
  pcId: Number(pcId) || 0,
});
